import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Reveal } from './Reveal';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-ink px-6 pb-20 pt-4" data-id="element-43" data-mp="1l9o616jt3vko">
      <Reveal data-id="element-44" data-mp="1gdgyxafoce15">
        <h2 className="font-serif text-[32px] font-bold leading-tight text-white" data-id="element-45" data-mp="1gdqt7a7r57cn">Preguntas frecuentes</h2>
        <div className="mt-8 border-t border-white/10" data-id="element-46" data-mp="2dz4y233ilagd">
          {faqs.map((item, i) => {
          const open = openIndex === i;
          const panelId = `faq-panel-${i}`;
          return <div key={item.q} className="border-b border-white/10" data-id="element-47" data-mp="240p1vlpmrb00" data-mpi={i}>
                <h3 data-id="element-48" data-mp="1z3ym6zhqmhf4">
                  <button type="button" aria-expanded={open} aria-controls={panelId} onClick={() => setOpenIndex(open ? null : i)} className="flex w-full items-center justify-between gap-4 py-5 text-left text-base font-semibold text-white focus:outline-none focus-visible:text-gold" data-id="element-49" data-mp="1z2dwbn6dbmnl">
                    <span data-id="element-50" data-mp="ugireqm7n54m">{item.q}</span>
                    <span aria-hidden="true" className="w-4 shrink-0 text-center text-xl font-normal leading-none text-gold" data-id="element-51" data-mp="fjs074mowzq3">
                      {open ? '−' : '+'}
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-52" data-mp="6qexxc2qklrc">
                  {open && <motion.div id={panelId} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-53" data-mp="bioiecl30tm8">
                      <p className="pb-5 pr-8 text-[15px] leading-relaxed text-muted" data-id="element-54" data-mp="3o03a88caubbd">{item.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </Reveal>
    </section>;
}